<div class="modal-configuration">
  <div class="header-container modal-header">
    <app-user-personal-information></app-user-personal-information>
  </div>
  <div class="modal-body">
    <div class="text-title-info modal-text-title-info">
      {{ 'SystemView.TITLE' | translate }}
    </div>
    <div class="text-info modal-text-info">
      {{ 'SystemsOptionsDescription.TITLE' | translate }}
    </div>
    <div class="modal-button">
      <app-context-button></app-context-button>
    </div>
  </div>
</div>